/*eslint-disable*/
export const BILL_LANG = {
    langList: ["en", "id", "hn", "cn", "ms", "th"],
    langCode: 'lan'
}